import { Avatar, Badge, Button, Dropdown, Layout, Menu, Select, Space, theme } from 'antd';
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Utils from '../../composants/utils/utils';
import { faBars, faBookReader, faCertificate, faClose, faCogs, faDashboard, faFileText, faGlobeAfrica, faHospitalAlt, faMarker, faMicrophoneAlt, faPlusCircle, faQrcode, faQuestionCircle, faShareAlt, faSliders, faUserFriends, faUserGroup, faUsersBetweenLines, faVault, faWarning, faWind } from "@fortawesome/free-solid-svg-icons";
import { faThemeco } from "@fortawesome/free-brands-svg-icons";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { CustomToast } from '../../composants/toast/CustomToast';
import Background from '../../composants/background/background';
import { LoadingContext } from '../../composants/loadingContext';
import { LanguageContext } from '../../composants/LanguageContext';
import CustomFooter from '../Footer/Footer';
import ReLoginModal from '../relogin/ReLoginModal';

const CustomHeader = ({ children }) => {
    const { user, droits, showReloginModal } = useSelector(state => state.authUser);
    const { Header, Sider, Content, Footer } = Layout;
    const [collapsed, setCollapsed] = useState(false);
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const { loading, setLoading } = useContext(LoadingContext);
    const { langue, setLangue } = useContext(LanguageContext);

    const language = (event) => {
        setLangue(event);
    }

    useEffect(() => {
        if (!user || !droits || droits.length === 0) {
            window.location.href = '/login';
        }
    }, []);

    const menu = [
        {
            roles: [Utils.PERMISSIONS.SEE_DASHBOARD.value],
            href: Utils.DASHBOARD,
            icon: faDashboard,
            name: Utils.keys.dashboard.name,
            id: Utils.keys.dashboard.id,
            title: Utils.keys.dashboard.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_PARAMETER.value],
            href: Utils.PARAMETRE,
            icon: faCogs,
            name: Utils.keys.parametre.name,
            id: Utils.keys.parametre.id,
            title: Utils.keys.parametre.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_USER.value],
            href: Utils.USER,
            icon: faUserGroup,
            name: Utils.keys.user.name,
            id: Utils.keys.user.id,
            title: Utils.keys.user.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_DENONCIATION.value],
            href: Utils.DENONCIATION,
            icon: faGlobeAfrica,
            name: Utils.keys.denonciation.name,
            id: Utils.keys.denonciation.id,
            title: Utils.keys.denonciation.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_GROUPE.value],
            href: Utils.GROUPE,
            icon: faUserGroup,
            name: Utils.keys.group.name,
            id: Utils.keys.group.id,
            title: Utils.keys.group.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_ARTICLE.value],
            href: Utils.ARTICLE,
            icon: faFileText,
            name: Utils.keys.article.name,
            id: Utils.keys.article.id,
            title: Utils.keys.article.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_TEMOIGNAGE.value],
            href: Utils.TEMOIGNAGE,
            icon: faMicrophoneAlt,
            name: Utils.keys.temoignage.name,
            id: Utils.keys.temoignage.id,
            title: Utils.keys.temoignage.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_USRAJ.value],
            href: Utils.USRAJ,
            icon: faHospitalAlt,
            name: Utils.keys.usraj.name,
            id: Utils.keys.usraj.id,
            title: Utils.keys.usraj.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_MISSION.value],
            href: Utils.MISSION,
            icon: faMarker,
            name: Utils.keys.mission.name,
            id: Utils.keys.mission.id,
            title: Utils.keys.mission.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_VALEUR.value],
            href: Utils.VALEUR,
            icon: faVault,
            name: Utils.keys.valeur.name,
            id: Utils.keys.valeur.id,
            title: Utils.keys.valeur.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_QUIZ.value, Utils.PERMISSIONS.GET_SONDAGE.value],
            href: Utils.QUIZZ,
            icon: faQuestionCircle,
            name: Utils.keys.quizz.name,
            id: Utils.keys.quizz.id,
            title: Utils.keys.quizz.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_FORMATION.value, Utils.PERMISSIONS.GET_FORMATION_ADMIN.value],
            href: Utils.ELEARNING,
            icon: faBookReader,
            name: Utils.keys.elearning.name,
            id: Utils.keys.elearning.id,
            title: Utils.keys.elearning.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_THEME.value],
            href: Utils.THEME,
            icon: faThemeco,
            name: Utils.keys.theme.name,
            id: Utils.keys.theme.id,
            title: Utils.keys.theme.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_ABOUT.value],
            href: Utils.APROPOS,
            icon: faPlusCircle,
            name: Utils.keys.apropos.name,
            id: Utils.keys.apropos.id,
            title: Utils.keys.apropos.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_CERTIFICATE.value],
            href: Utils.CERTIFICAT,
            icon: faCertificate,
            name: Utils.keys.certificate.name,
            id: Utils.keys.certificate.id,
            title: Utils.keys.certificate.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_SLIDER.value],
            href: Utils.SLIDERS,
            icon: faSliders,
            name: Utils.keys.slides.name,
            id: Utils.keys.slides.id,
            title: Utils.keys.slides.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.SEE_QRCODE.value],
            href: Utils.QRCODE,
            icon: faQrcode,
            name: Utils.keys.qrcode.name,
            id: Utils.keys.qrcode.id,
            title: Utils.keys.qrcode.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_ALERT.value],
            href: Utils.ALERT,
            icon: faWarning,
            name: Utils.keys.alert.name,
            id: Utils.keys.alert.id,
            title: Utils.keys.alert.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_WEATHER.value],
            href: Utils.WEATHER,
            icon: faWind,
            name: Utils.keys.weather.name,
            id: Utils.keys.weather.id,
            title: Utils.keys.weather.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_ALERT_TYPE.value, Utils.PERMISSIONS.GET_ALERT_TYPE_ADMIN.value],
            href: Utils.ALERTTYPE,
            icon: faWarning,
            name: Utils.keys.risk.name,
            id: Utils.keys.risk.id,
            title: Utils.keys.risk.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_CATEGORIE.value],
            href: Utils.CATEGORY,
            icon: faShareAlt,
            name: Utils.keys.category.name,
            id: Utils.keys.category.id,
            title: Utils.keys.category.description,
            children: []
        },
        {
            roles: [Utils.PERMISSIONS.GET_PARTENAIRE.value],
            href: Utils.PARTENAIRE,
            icon: faUsersBetweenLines,
            name: Utils.keys.partenaire.name,
            id: Utils.keys.partenaire.id,
            title: Utils.keys.partenaire.description,
            children: []
        }

    ];

    const [selectedKey, setSelectedKey] = useState(window.location.pathname);

    // Modify the getItem function to use Link instead of anchor
    function getItem(label, key, icon, children) {
        return {
            key,
            icon,
            children,
            label: <Link to={label.props.href}>{label.props.children}</Link>,
        };
    };

    const handleMenuClick = (e) => {
        setSelectedKey(e.key);
    };

    const subMenu = () => {
        const menus = [];
        menu.forEach(menuItem => {
            let hasRole = false;
            menuItem.roles.forEach(role => {
                if (droits.includes(role)) {
                    hasRole = true;
                }
            });
            if (hasRole) {
                menus.push(getItem(
                    <a href={menuItem.href} title={<FormattedMessage id={menuItem.title} />}>
                        {<FormattedMessage id={menuItem.name} />}
                    </a>,
                    menuItem.href,
                    <FontAwesomeIcon icon={menuItem.icon} />
                ));
            }
        });
        return menus;
    }

    const items = subMenu();

    const menuProps = {
        items: [
            {
                label: (
                    <div style={{ padding: '8px 4px' }} title={(user === null) ? "" : user?.prenom + ' ' + user?.nom}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 4 }}>
                            {(user === null) ? "" : user?.nom.toUpperCase()}
                        </div>
                        <div style={{ fontSize: 13, color: '#999' }}>
                            {(user === null) ? "" : user?.prenom}
                        </div>
                    </div>
                ),
                key: '0',
            },
            {
                type: 'divider',
            },
            {
                label: (
                    <Link rel="noopener noreferrer" to="/admin/profile" style={{ fontSize: 14 }}>
                        👤 Profile
                    </Link>
                ),
                key: '1',
            },
            {
                type: 'divider',
            },
            {
                label: (
                    <Link rel="noopener noreferrer" to="/home/contact" style={{ fontSize: 14 }}>
                        📧 Nous Contacter
                    </Link>
                ),
                key: '3',
            },
            {
                type: 'divider',
            },
            {
                label: (
                    <p
                        rel="noopener noreferrer"
                        onClick={() => {
                            window.location.href = '/';
                        }}
                        style={{
                            fontSize: 14,
                            color: '#ff4d4f',
                            margin: 0,
                            cursor: 'pointer'
                        }}
                    >
                        🚪 Déconnexion
                    </p>
                ),
                key: '4',
            },
        ],
    };

    return (
        <Layout className="min-h-screen flex flex-col">
            {/* Modal de reconnexion après 10 rafraîchissements de token */}
            {showReloginModal && <ReLoginModal />}
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                theme='light'
                className="fixed h-screen overflow-auto left-0 top-0 bottom-0"
                style={{
                    boxShadow: '2px 0 8px rgba(0, 0, 0, 0.06)',
                    borderRight: '1px solid #f0f0f0'
                }}
            >
                <div style={{
                    height: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '16px',
                    borderBottom: '1px solid #f0f0f0'
                }}>
                    {!collapsed ? (
                        <img src='/images/logo/logo.png' className='h-16' alt="Logo" style={{ maxWidth: '100%' }} />
                    ) : (
                        <img src='/images/logo/justlogo.png' className='h-16' alt="Logo" style={{ maxWidth: '100%' }} />
                    )}
                </div>
                <Menu
                    theme="light"
                    onClick={handleMenuClick}
                    selectedKeys={[selectedKey]}
                    mode="inline"
                    items={items}
                    style={{
                        borderRight: 0,
                        fontSize: 14
                    }}
                />
            </Sider>
            <Layout className={`transition-all duration-200 ${collapsed ? 'ml-20' : 'ml-52'}`}>
                <Header
                    className="sticky top-0 z-10 p-0 bg-white"
                    style={{
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                        borderBottom: '1px solid #f0f0f0'
                    }}
                >
                    <nav style={{ height: '64px', display: 'flex', alignItems: 'center', padding: '0 24px' }}>
                        <div className="flex flex-wrap items-center justify-between w-full">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                <Button
                                    type="text"
                                    icon={collapsed ? <FontAwesomeIcon icon={faBars} /> : <FontAwesomeIcon icon={faClose} />}
                                    onClick={() => setCollapsed(!collapsed)}
                                    style={{
                                        width: 40,
                                        height: 40,
                                        fontSize: 18,
                                        color: '#667eea',
                                        transition: 'all 0.3s'
                                    }}
                                    className="hover:bg-purple-50"
                                />
                                <h1 style={{
                                    margin: 0,
                                    fontSize: 20,
                                    fontWeight: 600,
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text'
                                }}>
                                    YouthFP
                                </h1>
                            </div>

                            {/* Financier UNFPA */}
                            <div className="hidden md:flex items-center gap-2" style={{
                                padding: '6px 16px',
                                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                                borderRadius: 8,
                                border: '1px solid rgba(102, 126, 234, 0.2)'
                            }}>
                                <img
                                    src="/images/pngegg.png"
                                    alt="UNFPA Cameroun"
                                    style={{
                                        height: 55,
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>

                            <div className="flex items-center gap-4 lg:order-2">
                                <Select
                                    placeholder={langue.toString().toUpperCase()}
                                    onChange={language}
                                    style={{
                                        minWidth: 80,
                                        borderRadius: 8
                                    }}
                                    variant="outlined"
                                    size="middle"
                                >
                                    <Select.Option value={Utils.TRADUCTION.fr}>
                                        🇫🇷 {Utils.TRADUCTION.fr.toUpperCase()}
                                    </Select.Option>
                                    <Select.Option value={Utils.TRADUCTION.en}>
                                        🇬🇧 {Utils.TRADUCTION.en.toUpperCase()}
                                    </Select.Option>
                                </Select>

                                <Dropdown menu={menuProps} placement="bottomRight">
                                    <a onClick={e => e.preventDefault()} style={{ cursor: 'pointer' }}>
                                        <Space
                                            className='px-2'
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: 8,
                                                transition: 'all 0.3s',
                                                background: 'transparent'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        >
                                            <Badge dot style={{ backgroundColor: '#52c41a' }}>
                                                <Avatar
                                                    size={40}
                                                    src={user?.photo == null ? '/images/profile-img.jpg' : user?.photo}
                                                    style={{
                                                        border: '2px solid #667eea',
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                            </Badge>
                                            <span
                                                className="font-semibold hidden lg:block"
                                                style={{
                                                    fontSize: 14,
                                                    color: '#333',
                                                    maxWidth: 120,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {user?.nom}
                                            </span>
                                        </Space>
                                    </a>
                                </Dropdown>
                            </div>
                        </div>
                    </nav>
                </Header>
                <Content className="min-h-[280px] rounded-lg py-6" style={{ background: '#f5f7fa' }}>
                    <Background />
                    <div className="flex-grow">
                        {children}
                        <CustomToast />
                    </div>
                </Content>
                <CustomFooter />
            </Layout>
        </Layout>
    );
}
export default CustomHeader;